import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { KeywordsExtracted } from '@models/keywordsExtracted.model';
import { KeywordExtractionService } from '@services/keyword-extraction.service';
import { BDMatrixFilter } from '@models/bdMatrixFilter.model';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { SortCriteria } from '@models/eliminationMatrixFilterModel';
import { StudyService } from '../../../../../services/study.service';
import { KeywordType, StudySearchStrategyProcess } from 'src/app/mystudies/_study_constants';

@Component({
  selector: 'app-extracted-keyword-list',
  templateUrl: './extracted-keyword-list.component.html',
  styleUrls: ['./extracted-keyword-list.component.css'],
})
export class ExtractedKeywordListComponent implements OnInit {
  @Input() readOnly: boolean;
  @Input() keywordExtractionService: KeywordExtractionService;
  @Input() keywordsChanged: any[];
  @ViewChild('extractedKeywordsTable', { static: true }) extractedKeywordsTable: Table;

  @Output() keywordSelected: EventEmitter<any> = new EventEmitter<any>();

  extractedKeywords: KeywordsExtracted[];
  newKeyword: string;
  keywordType: typeof KeywordType = KeywordType;
  filterRows: KeywordsExtracted[];
  keywords: KeywordsExtracted[];
  keywordsLoading = false;
  defaultPageSize = 50;
  searchText: string;

  private filter: BDMatrixFilter = new BDMatrixFilter();
  private _searchText: string;

  constructor(private studyService: StudyService) {}

  ngOnInit() {
    this.filter.pageIndex = 0;
    this.filter.pageSize = this.defaultPageSize;
  }

  async onSearchClick(): Promise<void> {
    // Filter the table

    this._searchText = this.searchText;
    this.textFilter();
    // reset pagination to first page
    this.reset();
  }

  async paginate(event: LazyLoadEvent): Promise<void> {
    if (this.keywordExtractionService.keywordExtractionStatus === StudySearchStrategyProcess.InProgress) {
      return;
    }

    setTimeout(async () => {
      try {
        this.keywordsLoading = true;
        this.searchText = this._searchText;
        this.filter.pageSize = event.rows;
        this.filter.pageIndex = Math.floor(event.first / event.rows);
        if (event.sortField) {
          this.filter.sortCriteria = new SortCriteria();
          this.filter.sortCriteria.ColumnName = event.sortField;
          this.filter.sortCriteria.isAscending = event.sortOrder === 1 ? true : false;
        }
        await this.getExtractedKeywords(this.filter);
      } finally {
        this.keywordsLoading = false;
      }
    });
  }

  selectKeyword(keyword: KeywordsExtracted, type: KeywordType) {
    // this.keywordExtractionService.selectKeyword(keyword, type);
    this.keywordSelected.emit({ keyword: keyword, type: type });
  }

  clearSelection(keyword: KeywordsExtracted) {
    keyword.keywordTypeId = null;
    this.keywordSelected.emit({ keyword: keyword, type: null });
  }

  public reset() {
    this.extractedKeywordsTable.reset();
  }

  private textFilter(): void {
    if (this._searchText) {
      this.filter.searchText = this._searchText;
    } else {
      this.filter.searchText = '';
    }
  }

  private async getExtractedKeywords(filter: BDMatrixFilter) {
    await this.keywordExtractionService.getFilteredExtractedKeywords(filter);

    this.updateExtractedKeywordsWithAppliedChanges();

    this.filterRows = this.keywordExtractionService.extractedKeywords;
  }

  private updateExtractedKeywordsWithAppliedChanges() {
    this.keywordsChanged.forEach((k) => {
      const extractedKeyword = this.keywordExtractionService.extractedKeywords.find((ek) => ek.keywordsExtractedId === k.keyword.keywordsExtractedId);
      if (extractedKeyword) {
        extractedKeyword.keywordTypeId = k.type;
      }
    });
  }
}
